import React from "react";

export interface PaziaSideNavItem {
  name: string;
  active: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const PaziaSideNav = ({
  items,
  className = "",
}: {
  items: PaziaSideNavItem[];
  className?: string;
}): JSX.Element => {
  return (
    <nav className={`flex w-48 shrink-0 flex-col gap-1 border-r border-slate-200 pr-2 dark:border-slate-700 ${className}`}>
      {items.map((item) => (
        <SideNavItem key={item.name} item={item} />
      ))}
    </nav>
  );
};

const SideNavItem = ({ item }: { item: PaziaSideNavItem }) => {
  const activeClasses =
    "bg-primary-50 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 font-semibold border-l-2 border-primary-600 dark:border-primary-400";
  const inactiveClasses =
    "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700/50 border-l-2 border-transparent";
  const disabledClasses =
    "text-slate-400 dark:text-slate-600 border-l-2 border-transparent cursor-not-allowed opacity-60";

  const getClasses = () => {
    if (item.active) return activeClasses;
    if (item.disabled) return disabledClasses;
    return inactiveClasses;
  };

  return (
    <button
      type="button"
      onClick={() => {
        if (!item.active && !item.disabled) item.onClick();
      }}
      disabled={item.disabled && !item.active}
      className={`rounded-r px-4 py-2 text-left text-sm transition-all duration-150 ${getClasses()}`}
    >
      {item.name}
    </button>
  );
};
